<template>
    <card>
        <template slot="header">
            <h3 class="card-title">Assign Memos to Collections</h3>
        </template>
        <div class="row">
        <div class="col-md-9">  
          <nav class="row">
          <ol class="breadcrumb arr-right bg-breadcrum">
              <li class="breadcrumb-item">
                  <router-link to="/hr/dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/hr/contractsmemo/">Contracts & Memos</router-link>
              </li>
              <li class="breadcrumb-item active">Assign Memos To Collections</li>
            </ol>
          </nav>
        </div>
        <div class="col-md-3">
          <div class="row pb-3">
            <div class="container">
              <p class="text-info"><i class="fa fa-newspaper-o"></i> &nbsp;&nbsp;Mass Assign Contracts/Memos</p>
              <select class="form-control" v-model="selectedRoute" @change="goToRoute" required>
                    <option value="">--------------------------------------------------------------------</option>
                    <option value="/hr/contracts/assign-all/">Assign Contracts to All</option>
                    <option value="/hr/memos/assign-all/">Assign Memos to All</option>
                    <option value="/hr/memos/assign-cd-pq/">Assign Memos to CD-PQ</option>
                    <option value="/hr/memos/assign-cd-hw/">Assign Memos to CD-HW</option>
                    <option value="/hr/memos/assign-mantra/">Assign Memos to Mantra</option>
                    <option value="/hr/memos/assign-va-nz-au/">Assign Memos to VA-NZ/AU</option>
                    <option value="/hr/memos/assign-va-us/">Assign Memos to VA-US</option>
                    <option value="/hr/memos/assign-collections/">Assign Memos to Collections</option>
                    <option value="/hr/memos/assign-admin/">Assign Memos to Admin</option>
              </select>
            </div>
          </div>
        </div>
      </div>
        <hr style="margin-top:-10px" />
        <br/>
        <form @submit.prevent="formSubmit">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <div class="row">
                            <div class="col-md-3">
                                <div class="title-header">Mass Assign Memos to Collections</div>
                            </div>
                            <div class="col-md-4"></div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="row">
                            <div class="col-md-6 offset-md-3">
                                <div class="upload-btn-wrapper ">
                                  <!-- Custom Button -->
                                    <button type="button" 
                                            class="btn-info btn mr-xl-2 mb-3"
                                             @click="openFileDialog">
                                       <div><i class="fa fa-newspaper-o"></i>&nbsp;Assign Memo</div>
                                    </button>                
                                   
                                    <!-- Hidden File Input -->
                                    <input type="file" 
                                           ref="files" 
                                           id="memoFiles" 
                                           multiple="multiple" 
                                           accept=".doc,.docx, .pdf" 
                                           @change="handleFileMemosUpload"
                                           style="display: none;" />
                                  
                                    <!-- Uploaded File Preview -->
                                    <div v-for="(file,key) in memoFiles" :key="key" class="mb-2">
                                        <slot v-if="file.type == 'application/pdf'">
                                            <i class="fa fa-file-pdf-o fa-2x"></i>
                                        </slot>
                                        <slot v-else-if="file.type=='application/msword'">
                                            <i class="fa fa-file-word-o fa-2x"></i>
                                        </slot> 
                                        <slot v-else-if="file.type=='application/vnd.openxmlformats-officedocument.wordprocessingml.document'">
                                            <i class="fa fa-file-word-o fa-2x"></i>
                                        </slot>  
                                            &nbsp;&nbsp; {{file.name}} - {{file.size}}
                                    <span @click="removeMemoFilesUpload(key)"><i class="fa fa-close" style="color:red;cursor: pointer;"></i></span>
                                    </div>                                                                  
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr style="margin-top:50px" />
                    <div class="form-group"><div class="float-right"><br> <button type="submit" class="btn btn-info"><i class="fa fa-location-arrow"></i>&nbsp;Submit Documents</button> <br> <br></div></div>
                </div>
            </div>
        </form>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <div class="col-md-12">
        <div class="row">
            <div class="col-md-7">
              <p><i class="fa fa-search"></i> Search Employee</p>
              <input type="test" v-model="search" class="form-control" placeholder="Search..."> 
            </div>
            <div class="col-md-2">
              <p><i class="fa fa-filter"></i> Filter By Year</p>
              <select v-model="filter_by_year"  @change="getYear" class="form-control" required>
                <option v-for="year in years(2019)">{{ year }}</option>
              </select>
            </div>
            <div class="col-md-1">
                  <div class="form-group">
                      <p><i class="fa fa-sort-numeric-asc"></i>&nbsp;Display</p>
                      <select v-model="page_limit" class="form-control" required>
                        <option value="">Default</option>
                        <option value="2">2</option>
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="500">500</option>
                      </select>
                  </div>
            </div>
              <div class="col-md-2">
                <div class="form-group">
                  <p><i class="fa fa-sort-amount-asc"></i>&nbsp;Order by </p>
                  <select v-model="order_by" class="form-control" required>
                      <option value="">Default</option>
                      <option value="1">ASC</option>
                      <option value="-1">DESC</option>
                  </select>
                </div>
              </div>               
        </div>
      </div>
      <hr>
  <!-- PAGINATION -->
  <b-pagination
  v-model="curentPage"
  :total-rows="items.length"
  :per-page="perPage"
      aria-controls="my-table"
      align="right"
      first-text="First"
      prev-text="Prev"
      next-text="Next"
      last-text="Last"
  ></b-pagination>
  <!-- END PAGINATION -->
  <hr>
      <div class="table-responsive ">
        <table class="table table-striped table-hover " v-loading="loading">
            <thead>
              <tr>
                  <th width="100">Employee Id</th>
                  <th width="150">Full Name</th>
                  <th width="150">Position</th>
                  <th width="100">Hired Date</th>
                  <th width="50">Status</th>
                  <th width="150">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item,index in computedRequest">
                  <template v-if="item === 'no data found'">
                      <td colspan="100%">
                          <h4><i class="fa fa-database"></i> Empty Records ...</h4>
                      </td>
                  </template>
                  <template v-else>
                      <td>{{item.emp_id}}</td>
                      <td>{{item.full_name}}</td>
                      <td>{{item.position_name | capitalize}}</td>   
                      <td>{{ getDate(item.employment_date)}}</td>
                      <td>
                        <span v-if="item.status == 'regular'">
                         <i class="fa fa-flag text-success"></i>&nbsp;{{item.status}}
                         </span>
                         <span v-else-if="item.status == 'probationary'">
                         <i class="fa fa-flag text-info"></i>&nbsp;{{item.status}}
                         </span>
                         <span v-else-if="item.status == 'trainee'">
                         <i class="fa fa-flag text-warning"></i>&nbsp;{{item.status}}
                         </span>
                      </td>
                      <td>
                        <div class="upload-btn-wrapper ">
                            <router-link :to="{name: 'assign-memos', params: { id: item.id }}" class="btn-info btn mr-xl-2 my-3">
                                  <div><i class="fa fa-newspaper-o"></i>&nbsp;Assign Memo</div>
                              </router-link>                                                                      
                          </div>
                      </td>
                    </template>
                  </tr>
            </tbody>
        </table>
        <br/>
    <!-- PAGINATION NATIVE WAY -->
          <div class="row">
              <div class="col-md-6">
                  <p style="color:#9a9a9a">Page {{curentPage}} out of {{total_item}} records</p>
              </div>
              <div class="col-md-6">
              <b-pagination
                  v-model="curentPage"
                  :total-rows="items.length"
                  :per-page="perPage"
                  aria-controls="my-table"
                  align="right"
                  first-text="First"
                  prev-text="Prev"
                  next-text="Next"
                  last-text="Last"
              ></b-pagination>
              </div>
          </div>
      <!-- END PAGINATION -->
      </div>  
  </card>
</template>
  <script>
  /* eslint-disable */
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  // import {mapState} from 'vuex'
  export default {
    components: {
      Card
    },
    data() {
      return {
           item: {},
           emp_id: '',
           full_name: '',
           document_type: '',
           memoFiles: [],
           files: {},
           uploadReady:true,
           //INPUT
           file_added:'',
           error_handler:[],
           items: [],
           selected_user: '',
           selected: {},
           search: '',
           order_by: '',
           filter_by_status: '',
           filter_by_type: '',
           filter_by_year:'',
           //SORTING
           page_limit: '',
           start_page: 1,
           loading: true,
           //PAGINATION
           perPage: 20,
           curentPage: 1,
           selectedRoute: ""
        }
    },
    created() {
      this.getAllEmployees()
      setTimeout(() => {
           this.loading = false;
        }, 300);
      
    },
    methods: {
      goToRoute() {
        if (this.selectedRoute) {
          this.$router.push(this.selectedRoute);
        }
      },
      getCurentUser() {
        axios.get('api/user', {
            headers: {
              Authorization: 'Bearer ' + localStorage.getItem('token')
            }
          })
          .then(response => {
            this.currentUser = response.data;
          })
          .catch(error => {
            console.log(error.response)
          });
      },
  
    
      getYear(){
          if(this.filter_by_year == ''){
             this.get_employees()
          }else{
             axios.get('api/contractsmemo/filteremployee/' + this.filter_by_year)
             .then(response => {
              this.items = response.data;
             })
            .catch(error => {
              console.log(error.response)
            });
          } 
        },
  
      getAllEmployees() {
        axios.get('api/contractsmemocollections', {
            headers: {
              Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
          })
          .then(response => {
            this.items = response.data;
          })
          .catch(error => {
            console.log(error.response)
          });
      },

      openFileDialog() {
        this.$refs.files.click(); // Opens the hidden file input
      },

      //FILE UPLOAD
      handleFileMemosUpload() {
        let uploadedContractFiles = event.target.files;
        if(!uploadedContractFiles.length)
            return
        for (let i = 0; i < uploadedContractFiles.length; i++){
                this.memoFiles.push( uploadedContractFiles[i])
        }
        console.log('response => ', uploadedContractFiles)
      },

      removeMemoFilesUpload(key){
          this.memoFiles.splice(key, 1)
    },
  
        /*
      |----------------------------------------------------------------------
      |  TO SUBMIT FORM 
      |----------------------------------------------------------------------
      */
      formSubmit() {
          this.$swal({
              title: 'Are you sure?',
              text: 'Do you want to upload these documents',
              type: 'warning',
              showCancelButton: true,
              showCloseButton: false,
          })
          .then((isConfirm) => {
            if (isConfirm === true) {
                //Form data a files to upload
                let formData = new FormData()
                if (this.memoFiles.length > 0){
                    for (var i = 0; i < this.memoFiles.length; i++) {
                        let file = this.memoFiles[i];
                        formData.append('files[' + i + ']', file);
                        //   console.log(formData);
                    }
                } else {
                    this.$swal({
                        title: 'Empty document!',
                        text: 'Please upload at least one document',
                        type: 'error',
                        showCloseButton: false,
                    })
                    return;
                }

                //HTTP POST Request
                  axios.post('api/assignmemos/collections', formData,{ 
                        headers: {
                              'Content-Type': 'multipart/form-data',
                              Authorization: "Bearer " + localStorage.getItem("token")
                          }
                      })
                    .then(resp => {
                        this.$swal('Success', 'Memo has been successfully assigned', 'success')
                        console.log(JSON.stringify(resp.data))
                    })
                    .catch(error => {
                      if (error.response.status == 422) {
                            this.error_handler = error.response.data.errors
                      }
                        console.log('response => ', error.response);
                    })
              }
          });
      }
    },
    computed: {

        offset() {
           return (this.start_page - 1) * this.page_limit;
        },
        limit() {
           return this.offset + this.page_limit;
        },
        total_item() {
           return this.items.length
        },
  
        computedRequest() {
           let filtered = this.items
           // USE IN PAGINATION 
           let start = (this.curentPage - 1) * this.perPage
           let end = this.curentPage * this.perPage
           filtered = filtered.slice(start, end)
  
           if (filtered.length > 0) {
  
              // SORTING NUMBER OF DISPLAY
              if (this.page_limit) {
                 filtered = filtered.slice(this.offset, this.limit);
                 return filtered
              }
  
              // SEARCH BY EMPLOYEE FULLNAME
              if (this.search) {
                 filtered = filtered.filter(
                    item => item.full_name.toLowerCase().indexOf(this.search) > -1
                 );
                 return filtered
              }
              // ORDER BY ASC AND DESC COMBOBOX
              if (this.order_by) {
                 filtered = filtered.slice(0).sort((a, b) => a.full_name < b.full_name ? this.order_by : this.order_by)
                 return filtered
              }
           } else {
              filtered = 0
           }
  
           return filtered
        },

        filePreview(){
            let data = window.axios.defaults.baseURL + '/upload/'
            return data
        }
    }
  }
  </script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-contracts-memo/todo-assign-memos-collections.vue